import Swiper, { Autoplay, FreeMode, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let latestWorksSwiperWr = document.querySelectorAll('.latest-works-swiper-wr');
latestWorksSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, FreeMode],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 20,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 640,
      },
      on: {
        afterInit: function () {
          wrapper.scrollWidth >= wrapper.clientWidth
            ? wrapper.classList.remove('justify-center')
            : wrapper.classList.add('justify-center');
        },

        resize: function () {
          wrapper.scrollWidth >= wrapper.clientWidth
            ? wrapper.classList.remove('justify-center')
            : wrapper.classList.add('justify-center');
        },
        /*touchMove: function (swiper, event) {
          if (cursor) {
            const touch = event.touches ? event.touches[0] : event;
            updateCursorPosition(touch.clientX, touch.clientY);
          }
        },

        sliderMove: function (swiper, event) {
          if (cursor) {
            const touch = event.touches ? event.touches[0] : event;
            updateCursorPosition(touch.clientX, touch.clientY);
          }
        },

        touchStart: function (swiper, event) {
          if (cursor) {
            const touch = event.touches ? event.touches[0] : event;
            updateCursorPosition(touch.clientX, touch.clientY);
          }
        },*/
      },
    });
    swiperObserver(swiper);
  }
});

/*
let lastX = 0;
let lastY = 0;
let requestID = null;*/

/*function updateCursorPosition(x, y) {
  if (cursor && cursor.el) {
    if (Math.abs(x - lastX) > 2 || Math.abs(y - lastY) > 2) {
      lastX = x;
      lastY = y;

      if (requestID !== null) {
        cancelAnimationFrame(requestID);
      }

      requestID = requestAnimationFrame(() => {
        cursor.el.style.transform = `translate3d(${lastX}px, ${lastY}px, 0)`;
      });
    }
  }
}*/
